var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStethoscope = function SvgStethoscope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78459 0.428223H5.49991V1.23114H6.38311V2.74329C6.38311 4.07146 5.30251 5.15206 3.97435 5.15206C2.64619 5.15206 1.56561 4.07148 1.56561 2.74331V1.23114H2.42206V0.428223H1.16415C0.942412 0.428223 0.762695 0.607939 0.762695 0.82968V2.74331C0.762695 4.51429 2.20339 5.95499 3.97437 5.95499C5.74535 5.95499 7.18605 4.51429 7.18605 2.74331V0.82968C7.18605 0.607939 7.00633 0.428223 6.78459 0.428223Z",
    fill: "#707683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35024 6.28952V8.18977C8.35024 9.2966 7.44977 10.1971 6.34293 10.1971C5.2361 10.1971 4.33563 9.2966 4.33563 8.18977V5.56689H3.53271V8.18977C3.53271 9.73927 4.79329 11 6.34293 11C7.89243 11 9.15315 9.73927 9.15315 8.18977V6.28952H8.35024Z",
    fill: "#707683"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75189 3.69336C7.93265 3.69336 7.26636 4.35965 7.26636 5.17876C7.26636 5.99775 7.93265 6.66417 8.75177 6.66417C9.57088 6.66417 10.2372 5.99775 10.2373 5.17876C10.2373 4.35965 9.57088 3.69336 8.75189 3.69336ZM8.75177 5.86126C8.37534 5.86126 8.06914 5.55508 8.06914 5.17879C8.06914 4.80249 8.37532 4.49631 8.75177 4.49631C9.12806 4.49631 9.43424 4.80249 9.43424 5.17879C9.43424 5.55508 9.12806 5.86126 8.75177 5.86126Z",
    fill: "#707683"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40866 0C2.18692 0 2.0072 0.179717 2.0072 0.401457V1.25791C2.0072 1.47965 2.18692 1.65937 2.40866 1.65937C2.6304 1.65937 2.81012 1.47965 2.81012 1.25791V0.401457C2.81012 0.179717 2.6304 0 2.40866 0Z",
    fill: "#707683"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51327 0C5.29153 0 5.11182 0.179717 5.11182 0.401457V1.25791C5.11182 1.47965 5.29153 1.65937 5.51327 1.65937C5.73501 1.65937 5.91473 1.47965 5.91473 1.25791V0.401457C5.91473 0.179717 5.73501 0 5.51327 0Z",
    fill: "#707683"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStethoscope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stethoscope.d41185ea.svg";
export { ForwardRef as ReactComponent };